import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const TicketKeyRoot = styled.div<{
  $enableCopy?: boolean;
  $marginLeft?: number;
  $marginRight?: number;
}>`
  display: flex;
  flex-direction: row;

  ${({ $enableCopy }) =>
    $enableCopy &&
    css`
      :hover .ticket-key-link {
        transform: translateX(0);
        opacity: 1;
      }
    `}

  ${({ $marginLeft }) =>
    $marginLeft &&
    css`
      margin-left: ${$marginLeft}px;
    `}

  ${({ $marginRight }) =>
    $marginRight &&
    css`
      margin-right: ${$marginRight}px;
    `}
`;

export const TicketKeyPill = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 0.6rem;
  border: 2px solid ${vars.colors.grey80};
  background: ${vars.colors.grey100};
  border-radius: 1.4rem;
`;

export const TicketKeyText = styled(Paragraph)`
  font-family: Roobert, serif;
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
`;

export const TicketKeyLink = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 0.5rem;
  padding: 0;

  background: none;
  outline: none;
  border: none;

  transform: translateX(-50%);
  opacity: 0;
  transition: transform 0.2s ease, opacity 0.2s ease;
`;
